module.exports = __webpack_public_path__ + "img/logo-doen.8519aa4.svg";